import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {LinkForm} from '../../../../shared/link/link.form';
import {ValueLists} from '@common/core/services/value-lists.service';
import {CurrentUser} from '@common/auth/current-user';
import { BehaviorSubject, combineLatest } from 'rxjs';
import {LinkOptionsList} from '../../../link/types';
import {FormBuilder} from '@angular/forms';
import {LinkGroup} from '../../../../shared/link/link-group';
import {Settings} from '@common/core/config/settings.service';
import {BiolinkEditorService} from '../biolink-editor.service';
import { filter, finalize, take } from 'rxjs/operators';
import {CrupdateLinkFeature} from '../../../link/crupdate-link-feature';
import { Toast } from '@common/core/ui/toast.service';
import { BackendErrorResponse } from '@common/core/types/backend-error-response';

@Component({
    selector: 'biolink-settings',
    templateUrl: './biolink-settings.component.html',
    styleUrls: ['./biolink-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LinkForm],
})
export class BiolinkSettingsComponent implements OnInit {
    hiddenFeatures: {[key in CrupdateLinkFeature]?: boolean} = {
        alias: true,
        linkGroups: true,
        details: true,
    };
    slugBaseUri$ = new BehaviorSubject<string>(null);
    options$ = new BehaviorSubject<LinkOptionsList>(null);
    form = this.fb.group({
        name: '',
    });
    errors$ = new BehaviorSubject<Partial<LinkGroup>>({});

    constructor(
        public linkForm: LinkForm,
        private valueLists: ValueLists,
        private currentUser: CurrentUser,
        private fb: FormBuilder,
        private settings: Settings,
        public editor: BiolinkEditorService,
        private toast: Toast,
    ) {}

    ngOnInit() {
        this.valueLists
            .get(['countries', 'domains', 'pixels'], {
                userId: this.currentUser.get('id'),
            })
            .subscribe(response => {
                this.options$.next(response);
            });

        // on domain change wait until domain list is loaded from backend
        combineLatest(
            this.linkForm.formGroup.get('domain_id').valueChanges,
            this.options$.pipe(filter(o => !!o)),
        ).subscribe(([domainId, _]) => {
            this.setSlugBaseUri(domainId);
        });

        this.editor.biolink$
            .pipe(
                filter(biolink => !!biolink),
                take(1)
            )
            .subscribe(biolink => {
                this.linkForm.patchValue(biolink);
            });
    }

    saveSettings() {
        this.editor.loading$.next(true);
        return this.editor.biolinks
            .update(this.editor.biolink$.value.id, this.linkForm.value() as any)
            .pipe(finalize(() => this.editor.loading$.next(false)))
            .subscribe(() => {
                this.toast.open('Biolink updated');
            }, (err: BackendErrorResponse) => this.errors$.next(err.errors));
    }

    private setSlugBaseUri(domainId: number) {
        if (domainId) {
            this.slugBaseUri$.next(
                this.options$.value.domains.find(d => d.id === domainId).host
            );
        } else {
            this.slugBaseUri$.next(this.settings.getBaseUrl());
        }
    }
}
